import { ReactElement } from "react";
import HubDetails from "../../components/Hubs/Details";
import Layout from "../../components/layout";

const HubDetailsPage = (): ReactElement => {
  return (
    <Layout>
      <HubDetails />
    </Layout>
  );
};

export default HubDetailsPage;
